document.addEventListener('DOMContentLoaded', function() {
    const stickyWrapper = document.getElementById('sticky-add-to-cart__wrapper');

    function toggleStickyButton() {
        // Überprüfen, ob der Bildschirm kleiner als 768px ist
        if (window.innerWidth < 768) {
            if (window.scrollY > 1000) {
                stickyWrapper.style.display = 'block';  // Show the wrapper when scrolled down and screen is smaller than 768px
            } else {
                stickyWrapper.style.display = 'none';   // Hide the wrapper when scrolled up
            }
        } else {
            stickyWrapper.style.display = 'none';  // Hide the wrapper if the screen is larger than 768px
        }
    }

    // Initial check in case the page is loaded at a scroll position
    toggleStickyButton();

    // Listen for scroll and resize events
    window.addEventListener('scroll', toggleStickyButton);
    window.addEventListener('resize', toggleStickyButton);  // Ensure it works on window resize as well
});


document.addEventListener('DOMContentLoaded', function() {
    // Funktion zum Aktualisieren des Bruttopreises
    function updateBruttoPrice() {
        const priceElement = document.querySelector('.price--main .money'); // Der Nettopreis der Variante
        const bruttoPriceElement = document.querySelector('.brutto_netto_info'); // Bruttopreis-Element
        
        if (priceElement && bruttoPriceElement) {
            // Nettopreis aus dem Preis-Element extrahieren und in eine Zahl umwandeln
            const netPrice = parseFloat(priceElement.innerText.replace(/[^0-9,.]/g, ''));
            
            const taxRate = 0.19; // 19% tax rate
            
            
            // Bruttopreis berechnen (z.B. 19% MwSt.)
            // const bruttoPrice = (netPrice * 1.19);
            let bruttoPrice = price + (price * taxRate);
            let fixedPrice = totalPrice.toFixed(2);
          
            
            // Bruttopreis-Element aktualisieren
            bruttoPriceElement.innerHTML = `Bruttopreis: €${fixedPrice}`;
        }
    }

    // Event-Listener für Variantenwechsel hinzufügen
    document.querySelector('form[action="/cart/add"]').addEventListener('change', function(event) {
        if (event.target.name === 'id') {
            updateBruttoPrice(); // Preis bei Variantenwechsel aktualisieren
        }
    });

    // MutationObserver, um dynamische Änderungen des Preises zu überwachen
    const priceElement = document.querySelector('.price--main');
    const observer = new MutationObserver(updateBruttoPrice);

    if (priceElement) {
        observer.observe(priceElement, { childList: true, subtree: true });
    }

    // Initiales Setzen des Bruttopreises beim Laden der Seite
    updateBruttoPrice();
});



